module.exports = __webpack_public_path__ + "bede71b881b798388005b0d003a95fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotateIcon.png
// module id = 1793
// module chunks = 5